<template>
  <hm-content title="新增商品">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="product-ruleForm"
    >
      <el-form-item label="商品分类：" prop="categoryId">
        <el-select
          clearable
          v-model="ruleForm.categoryId"
          placeholder="选择分类"
          size="small"
          filterable
          class="mr10"
        >
          <el-option
            v-for="item in categoryList.list"
            :key="item.id"
            :label="item.categoryName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商品类型：">
        <el-radio-group v-model="ruleForm.productType" size="small">
          <el-radio :label="1">服务商品</el-radio>
          <el-radio :label="2">实物商品</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="商品名称：" prop="productName">
        <el-input
          size="small"
          clearable
          class="mr10 ipt"
          v-model.trim="ruleForm.productName"
          placeholder="请输入商品名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="商品售价：" prop="price">
        <el-input
          size="small"
          clearable
          @mousewheel.prevent.native
          type="number"
          v-model.trim="ruleForm.price"
          class="mr10 ipt"
        ></el-input>
      </el-form-item>
      <el-form-item label="会员售价：" prop="memberPrice">
        <el-input
          size="small"
          clearable
          @mousewheel.prevent.native
          type="number"
          v-model.trim="ruleForm.memberPrice"
          class="mr10 ipt"
        ></el-input>
      </el-form-item>
      <el-form-item label="主图：" prop="listHeader">
        <my-upload
          field="file"
          @crop-success="cropSuccess"
          @crop-upload-success="cropUploadSuccess"
          @crop-upload-fail="cropUploadFail"
          v-model="show"
          noCircle
          noSquare
          :width="345"
          :height="180"
          :data="{ fileDir: 'mall' }"
          :headers="{ 'X-Access-Token': $token }"
          :action="$uploadUrl"
          img-format="png"
        ></my-upload>
        <el-button
          type="primary"
          size="small"
          v-show="!listHeaderImgUrl"
          @click="toggleShow"
          >上传</el-button
        >
        <span class="form-tip">（主图仅可设置一张，图片尺寸建议345x180）</span>
        <div class="priview" v-if="listHeaderImgUrl">
          <img :src="listHeaderImgUrl" alt="主图" />
          <div class="opreat-wrapper flex item-center flex-center">
            <el-button type="text" @click="handleRemove">删除</el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="商品状态：">
        <div class="flex item-center">
          <el-switch
            style="display: block"
            v-model="ruleForm.status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="上架"
            inactive-text="下架"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
          <span class="form-tip">（关闭后，不出现在服务内）</span>
        </div>
      </el-form-item>
      <div class="flex flex-center">
        <el-button type="primary" size="small" @click="submitForm('ruleForm')"
          >提交</el-button
        >
        <el-button size="small" @click="$router.back(-1)">返回</el-button>
      </div>
    </el-form>
  </hm-content>
</template>

<script>
import moment from "moment";

import { mapGetters } from "vuex";
import { getLoginUser } from "@/utils/auth";
import myUpload from "vue-image-crop-upload";

 export default {
  components: {   myUpload },
  data() {
    const patternProductType = function(rule, val, callback) {
      if (this.chargeType === 0) {
        if (
          /^[1-9]\d*$/.test(this.ruleForm.totTime) &&
          /^[1-9]\d*$/.test(this.ruleForm.useTime) &&
          this.ruleForm.totTime >= this.ruleForm.useTime
        ) {
          callback();
        } else if (this.ruleForm.totTime < this.ruleForm.useTime) {
          return callback(new Error("每次消耗不能大于总次数"));
        } else {
          return callback(new Error("请输入大于0的正整数"));
        }
      } else if (this.chargeType === 1) {
        if (
          this.ruleForm.totTime > 0 &&
          this.ruleForm.useTime > 0 &&
          this.ruleForm.totTime >= this.ruleForm.useTime
        ) {
          callback();
        } else if (this.ruleForm.totTime < this.ruleForm.useTime) {
          return callback(new Error("每次消耗不能大于总时长"));
        } else {
          return callback(new Error("请输入大于0的数"));
        }
      }
    }.bind(this);
    const patternPrice = function(rule, val, callback) {
      if (this.ruleForm.price && this.ruleForm.price >= 0) {
        const isFloat = String(this.ruleForm.price).indexOf(".") > -1;
        if (
          Number.isInteger(+this.ruleForm.price) ||
          (isFloat && String(this.ruleForm.price).split(".")[1].length <= 2)
        ) {
          callback();
        } else {
          return callback(new Error("售价最多保留两位小数"));
        }
      } else {
        return callback(new Error("请输入售价，且售价应大于或等于0"));
      }
    }.bind(this);
    const patternMemberPrice = function(rule, val, callback) {
      if (val && val >= 0) {
        const isFloat = String(val).indexOf(".") > -1;
        if (
          (Number.isInteger(+val) ||
            (isFloat && String(val).split(".")[1].length <= 2)) &&
          +val <= +this.ruleForm.price
        ) {
          callback();
        } else {
          return callback(
            new Error("会员价最多保留两位小数,且应小于或等于商品售价")
          );
        }
      } else {
        return callback(new Error("请输入会员价，且会员价应大于或等于0"));
      }
    }.bind(this);
    const patternListHeader = function(rule, val, callback) {
      if (!this.listHeaderImgUrl) {
        return callback(new Error("请上传主图"));
      }
      callback();
    }.bind(this);
    const patternListDetail = function(rule, val, callback) {
      if (this.uploadedDetailList.length <= 0) {
        return callback(new Error("请上传列表详情图"));
      }
      callback();
    }.bind(this);
    return {
      showDetail: false,
      show: false,
      inputVisible: false,
      isMininum: true,
      inputValue: "",
      activeTab: 0,
      type: 0,
      uploadedDetailList: [],
      listHeaderImgUrl: "",
      storeId: "",
      startDate: "",
      validDate: "",
      endDate: "",
      editorOption: {},
      chargeType: "",
      ruleForm: {
        categoryId: "",
        productTags: [],
        serverId: "",
        productName: "",
        productType: 1,
        validType: 1,
        recommendStatus: 0,
        status: 1,
        totTime: "",
        useTime: "",
        specification: "",
        price: "",
        validDay: "",
        validSpaceDay: "",
        dateAndTime: "",
        imgTxt: "",
        memberPrice: ""
      },
      rules: {
        categoryId: {
          required: true,
          message: "请选择商品分类",
          trigger: "change"
        },
        imgTxt: [
          { required: true, message: "请输入图文详情", trigger: "blur" }
        ],
        serverId: [
          { required: true, message: "请选择服务", trigger: "change" }
        ],
        productName: [
          { required: true, message: "请输入商品名", trigger: "blur" }
        ],
        productType: [
          { required: true, validator: patternProductType, trigger: "blur" }
        ],
        price: [{ required: true, validator: patternPrice, trigger: "blur" }],
        memberPrice: [
          { required: true, validator: patternMemberPrice, trigger: "blur" }
        ],
        listHeader: [
          {
            required: true,
            validator: patternListHeader,
            trigger: "blur"
          }
        ],
        listDetail: [
          {
            required: true,
            validator: patternListDetail,
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: mapGetters(["categoryList"]),
  watch: {
    "ruleForm.validType": {
      handler(v) {
        this.$refs.period.clearValidate();
        if (v === 1) {
          this.ruleForm.dateAndTime = "";
        } else if (v === 2) {
          this.ruleForm.validDay = "";
          this.ruleForm.validSpaceDay = "";
        } else {
          this.validDate = "不限时间";
        }
        this.formatValidDate(v);
      },
      deep: true
    },
    "ruleForm.dateAndTime": {
      handler(val) {
        this.startDate = val ? moment(val[0]).format("YYYY-MM-DD") : "";
        this.endDate = val ? moment(val[1]).format("YYYY-MM-DD") : "";
      },
      deep: true
    }
  },
  mounted() {
    const { storeId } = getLoginUser();
    this.storeId = storeId;
    // this.$store.dispatch("queryServiceList", { pageSize: 999 });
    this.$store.dispatch("queryCategoryList", {
      pageSize: 999
    });
  },
  methods: {
    toggleShow() {
      this.show = !this.show;
    },
    toggleShowDetail() {
      this.showDetail = !this.showDetail;
    },
    cropSuccess() {},
    /**
     * upload success
     *
     * [param] jsonData   服务器返回数据，已进行json转码
     * [param] field
     */
    cropUploadSuccess(jsonData) {
      if (this.show) {
        this.listHeaderImgUrl = jsonData.result;
      } else if (this.showDetail) {
        this.uploadedDetailList.push(jsonData.result);
      }
    },
    cropUploadFail() {},
    formatValidDate(type) {
      if (type === 0) {
        this.validDate = "不限时间";
      } else if (type === 1) {
        this.validDate = `购买后${this.ruleForm.validSpaceDay}天后生效，有效期${this.ruleForm.validDay}天`;
      } else if (type === 2) {
        const startDate = this.ruleForm.dateAndTime[0]
          ? moment(this.ruleForm.dateAndTime[0]).format("YYYY-MM-DD")
          : "";
        const endDate = this.ruleForm.dateAndTime[1]
          ? moment(this.ruleForm.dateAndTime[1]).format("YYYY-MM-DD")
          : "";
        this.validDate = `${startDate}-${endDate}`;
      }
    },
    minimum() {
      this.isMininum = !this.isMininum;
    },
    getChargeType(id) {
      this.chargeType = id
        ? this.serviceList.list.find(v => v.id === id).chargeType
        : "";
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleClose(tag) {
      this.ruleForm.productTags.splice(
        this.ruleForm.productTags.indexOf(tag),
        1
      );
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.ruleForm.productTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = this.ruleForm;
          params = Object.assign(params, {
            detailImg: this.uploadedDetailList.join(","),
            listImg: this.listHeaderImgUrl,
            productTags: this.ruleForm.productTags,
            validStartDate: this.ruleForm.validType === 2 ? this.startDate : "",
            validEndDate: this.ruleForm.validType === 2 ? this.endDate : ""
          });
          this.$store.dispatch("addProduct", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 移除上传文件
    handleRemove() {
      this.listHeaderImgUrl = "";
    },
    // 上传成功后的回调
    uploadSuccess(response) {
      this.listHeaderImgUrl = response.result;
      this.$message({
        type: "success",
        message: "上传成功！"
      });
    },
    // 上传错误
    uploadError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
    },
    // 上传前对文件的大小的判断
    beforeUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpg";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      const limitSize = file.size / 1024 <= 300;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      if (!limitSize) {
        this.$message({
          message: "上传模板大小不能超过 300k!",
          type: "warning"
        });
      }
      const isSize = new Promise((resolve, reject) => {
        let width = 345;
        let height = 180;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          return file;
        },
        () => {
          this.$message({
            message: "请上传345*180的图片!",
            type: "warning"
          });
          return Promise.reject();
        }
      );
      return (
        (extension || extension2 || extension3 || extension4) &&
        limitSize &&
        isSize
      );
    },
    handleRemoveListDetail(file) {
      if (typeof file === "number") {
        this.uploadedDetailList.splice(file, 1);
      } else {
        const index = this.uploadedDetailList.findIndex(
          v => v === file.response.result
        );
        this.uploadedDetailList.splice(index, 1);
      }
    },
    uploadListDetailError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
    },
    uploadListDetailSuccess(response) {
      this.uploadedDetailList.push(response.result);
      this.$message({
        type: "success",
        message: "上传成功！"
      });
    },
    setFirst(i) {
      let tmp = this.uploadedDetailList[0];
      this.uploadedDetailList[0] = this.uploadedDetailList[i];
      this.uploadedDetailList[i] = tmp;
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped lang="scss">
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.priview {
  position: relative;
  width: 375px;
  height: 178px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.preview-wrapper {
  position: fixed;
  top: 100px;
  right: 30px;
  width: 365px;
  z-index: 10;
}
</style>
